import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TaskInspectionFenceIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4 7H20V4H23V19H20V17H4V19H1V4H4V7ZM2 18H3V5H2V18ZM21 18H22V5H21V18ZM4 16H20V14H4V16ZM4 11V13H20V11H4ZM4 10H20V8H4V10Z'
        />
    ),
})

TaskInspectionFenceIcon.displayName = 'TaskInspectionFenceIcon'
